// extracted by mini-css-extract-plugin
export default {"h1Title":"errors_h1Title__OQpt9","image":"errors_image__JSnZz","wrap":"errors_wrap__zWwrZ","text":"errors_text__yEfkm","hint":"errors_hint__xGnmt","support":"errors_support__0HLKJ"};